import { useTranslation } from 'react-i18next'
import { Wrench, Coins, Circle, Sprout, Package, Wallet } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { ZakatType } from '@/types/zakat'

interface ZakatTypeOption {
  type: ZakatType
  labelKey: string
  icon: React.ElementType
}

const zakatTypes: ZakatTypeOption[] = [
  { type: 'freelance', labelKey: 'zakat.types.freelance', icon: Wrench },
  { type: 'livestock', labelKey: 'zakat.types.livestock', icon: Package },
  { type: 'crops', labelKey: 'zakat.types.crops', icon: Sprout },
  { type: 'silver', labelKey: 'zakat.types.silver', icon: Circle },
  { type: 'gold', labelKey: 'zakat.types.gold', icon: Coins },
  { type: 'money', labelKey: 'zakat.types.money', icon: Wallet },
]

interface ZakatTypeSelectorProps {
  selectedType: ZakatType
  onTypeChange: (type: ZakatType) => void
}

export default function ZakatTypeSelector({
  selectedType,
  onTypeChange,
}: ZakatTypeSelectorProps) {
  const { t } = useTranslation()
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
      {zakatTypes.map(({ type, labelKey, icon: Icon }) => (
        <button
          key={type}
          type="button"
          onClick={() => onTypeChange(type)}
          className={cn(
            'flex flex-col items-center justify-center gap-3 p-6 rounded-lg border-2 transition-all',
            'hover:shadow-lg min-h-[120px]',
            selectedType === type
              ? 'bg-primary-600 border-primary-600 text-white shadow-md'
              : 'bg-white border-gray-200 text-gray-700 hover:border-primary-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300'
          )}
        >
          <Icon className="w-10 h-10" />
          <span className="text-sm font-semibold text-center leading-tight">{t(labelKey)}</span>
        </button>
      ))}
    </div>
  )
}

